module.exports = __webpack_public_path__ + "images/emoji/raised_hands.9edf87e7dd87d61512da.png";